import React from 'react';
import FilterGroupSearch from './FilterGroupSearch';

const SearchFilterGroupContainer = ({
  setTabValue,
  handleClose,
  setRecordFormatFilterGroupCode,
  setSelectedFilterGroupCode,
  setFilterGroupCode,
  setSelectedRows,
  selectedRows,
}) => {
  return (
    <>
      <FilterGroupSearch
        setSelectedRows={setSelectedRows}
        selectedRows={selectedRows}
        setFilterGroupCode={setFilterGroupCode}
        setTabValue={setTabValue}
        setSelectedFilterGroupCode={setSelectedFilterGroupCode}
        handleClose={handleClose}
        setRecordFormatFilterGroupCode={setRecordFormatFilterGroupCode}
      />
    </>
  );
};
export default SearchFilterGroupContainer;
